export const constantes = {
  APLICACION: process.env.WEBAPP,
  GOOGLE_AUTH: process.env.GOOGLE_AUTH,
  LAVANDERIA: process.env.WEBAPPLAVANDERIA,
  MS_AUTENTICACION: process.env.MS_AUTENTICACION,
  MS_AUDITORIA: process.env.MS_AUDITORIA,
  MS_LOGISTICA: process.env.MS_LOGISTICA,
  GOOGLE_KEY: process.env.GOOGLE_KEY,
};
